import ConfigurationService from '../Service/ConfigurationService';
import { RequestConfig } from 'tree-wallet-client';
import { request } from '../Helper/Http';

export const Translations = [
  'latin',
  'italian',
  'english',
  'spanish',
];

export async function getTreeTypesList(config: RequestConfig) {
  const { params } = config;
  const suffix = (params?.contractId ? `/${params.contractId}` : '')
  const url = `${ConfigurationService.urls().treeTypeListUrl}${suffix}`;
  return await request(url, config);
}
